import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1768beae = () => interopDefault(import('../pages/attendance/index.vue' /* webpackChunkName: "pages/attendance/index" */))
const _3b16c10a = () => interopDefault(import('../pages/doccompany/index.vue' /* webpackChunkName: "pages/doccompany/index" */))
const _687d9a90 = () => interopDefault(import('../pages/docprivate/index.vue' /* webpackChunkName: "pages/docprivate/index" */))
const _1b3759ea = () => interopDefault(import('../pages/event/index.vue' /* webpackChunkName: "pages/event/index" */))
const _4e1c55c9 = () => interopDefault(import('../pages/holiday/index.vue' /* webpackChunkName: "pages/holiday/index" */))
const _2b4fe6b8 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _251acde6 = () => interopDefault(import('../pages/overtime/index.vue' /* webpackChunkName: "pages/overtime/index" */))
const _3b6d05da = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _3324e20e = () => interopDefault(import('../pages/reimbursment/index.vue' /* webpackChunkName: "pages/reimbursment/index" */))
const _0bb99439 = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _6769fb6a = () => interopDefault(import('../pages/sallary/index.vue' /* webpackChunkName: "pages/sallary/index" */))
const _3b6cacc0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/attendance",
    component: _1768beae,
    name: "attendance"
  }, {
    path: "/doccompany",
    component: _3b16c10a,
    name: "doccompany"
  }, {
    path: "/docprivate",
    component: _687d9a90,
    name: "docprivate"
  }, {
    path: "/event",
    component: _1b3759ea,
    name: "event"
  }, {
    path: "/holiday",
    component: _4e1c55c9,
    name: "holiday"
  }, {
    path: "/home",
    component: _2b4fe6b8,
    name: "home"
  }, {
    path: "/overtime",
    component: _251acde6,
    name: "overtime"
  }, {
    path: "/profile",
    component: _3b6d05da,
    name: "profile"
  }, {
    path: "/reimbursment",
    component: _3324e20e,
    name: "reimbursment"
  }, {
    path: "/report",
    component: _0bb99439,
    name: "report"
  }, {
    path: "/sallary",
    component: _6769fb6a,
    name: "sallary"
  }, {
    path: "/",
    component: _3b6cacc0,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
